module.exports = __webpack_public_path__ + "img/thermocouple-end-K.195c5054.png";